import { useContext, useEffect } from 'react';

import { useRouter } from 'next/router';

import { AtlasEventsContext } from '@atlas/contexts/events';

import { MapContextType } from './map-context';
import { updateUrlWithBounds } from './map-context.utils';
import { MapViewState } from './map-context.types';

export const useMapDataEvents = ({ zoomTo, setBounds }: MapContextType) => {
  const { on } = useContext(AtlasEventsContext);

  useEffect(
    () => on('mapZoomTo', ({ center, zoom }) => zoomTo(center, zoom)),
    [],
  );

  useEffect(() => on('mapSetBounds', ({ bounds }) => setBounds(bounds)), []);
};

export const useViewStateInUrl = (
  viewState: MapViewState,
  initialized: boolean,
) => {
  const router = useRouter();
  useEffect(() => {
    if (!initialized) return;

    updateUrlWithBounds(viewState.bounds);
  }, [viewState, router.replace]);
};
